import NonFundAssetsTable from "domains/liquidity/components/NonFundAssetsTable/NonFundAssetsTable";

export default NonFundAssetsTable;
